// import React, { useState, useEffect } from "react";
// import "../index.css"; 

// export default function HeroTextAnimation() {
// const words = ["WELCOME", "TO", "LABTOUCH", "PATHOLOGY..",];

//   const [displayedWords, setDisplayedWords] = useState([]);
//   const [index, setIndex] = useState(0);
//   const [reverse, setReverse] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (!reverse) {
//         setDisplayedWords(words.slice(0, index + 1));
//         setIndex((prev) => {
//           if (prev + 1 === words.length) setReverse(true);
//           return prev + 1;
//         });
//       } else {
//         setDisplayedWords(words.slice(0, index - 1));
//         setIndex((prev) => {
//           if (prev - 1 === 0) setReverse(false);
//           return prev - 1;
//         });
//       }
//     }, 700);

//     return () => clearInterval(interval);
//   }, [index, reverse, words]);

//   return (
//     <h1 className="text-4xl md:text-5xl font-extrabold leading-tight text-white">
//   {displayedWords.join(" ")}
//   <span className="animate-blink">|</span>
// </h1>

//   );
// }


// import React from "react";
// import "../index.css";

// export default function HeroTextAnimation() {
//   const text = "WELCOME TO LABTOUCH PATHOLOGY";

//   return (
//     <h1 className="hero-wave text-4xl md:text-5xl font-extrabold text-white">
//       {text.split("").map((char, index) => (
//         <span
//           key={index}
//           style={{ animationDelay: `${index * 0.1}s` }}
//         >
//           {char === " " ? "\u00A0" : char}
//         </span>
//       ))}
//     </h1>
//   );
// }



// import React from "react";
// import "../index.css";

// export default function HeroTextAnimation() {
//   const words = ["WELCOME", "TO", "LABTOUCH", "PATHOLOGY"];

//   return (
//     <h1 className="text-4xl md:text-5xl font-extrabold text-white flex flex-wrap gap-3">
//       {words.map((word, index) => (
//         <span
//           key={index}
//           className="word-wave"
//           style={{ animationDelay: `${index * 0.3}s` }}
//         >
//           {word}
//         </span>
//       ))}
//     </h1>
//   );
// }



import React from "react";
import "../index.css";

export default function HeroTextAnimation() {
  const words = ["WELCOME", "TO", "LABTOUCH.."];

  return (
    <h1
      className="
        font-extrabold text-white
        text-2xl sm:text-3xl md:text-5xl
        flex gap-2
        whitespace-nowrap
      "
    >
      {words.map((word, index) => (
        <span
          key={index}
          className="word-wave"
          style={{ animationDelay: `${index * 0.3}s` }}
        >
          {word}
        </span>
      ))}
    </h1>
  );
}
